export const configs = {
  storeDomain: 'bassike.myshopify.com',
  storefrontAccessToken: 'dcb3cc2ec54bf04e7586c21aaa5903e8',
};